import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: { minWidth: 375, p: 1 } as SxProps<Theme>,
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'column',
        gap: 1.5,
        py: 1,
    } as SxProps<Theme>,
    title: {
        fontSize: '18px',
        fontWeight: 700,
        ml: 2,
        alignSelf: 'flex-start',
    } as SxProps<Theme>,
    tabsRow: { display: 'flex', gap: 1, ml: 2, alignSelf: 'flex-start' } as SxProps<Theme>,
    tabBtn: (selected: boolean, theme: Theme): SxProps<Theme> => ({
        fontSize: '14px',
        fontWeight: 500,
        borderRadius: '8px',
        textTransform: 'capitalize',
        padding: '6px 16px',
        minWidth: 'unset',
        border: `1px solid ${selected ? theme.palette.primary.main : theme.palette.grey[100]}`,
        color: selected ? theme.palette.primary.main : theme.palette.grey[300],
        backgroundColor: selected ? theme.palette.blue[40] : 'white',
        '&:hover': {
            backgroundColor: theme.palette.blue[40],
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
        },
    }),
    list: {
        borderTop: '1px solid',
        borderColor: 'grey.50',
        maxHeight: '500px',
        minHeight: 240,
        overflow: 'auto',
    } as SxProps<Theme>,
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 5,
        gap: 2,
        color: 'grey.400',
    } as SxProps<Theme>,
    channelRow: (theme: Theme): SxProps<Theme> => ({
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1.5, 2),
        gap: 1.5,
        borderBottom: `1px solid ${theme.palette.grey[50]}`,
        cursor: 'pointer',
        '&:hover': { background: theme.palette.grey[30] },
    }),
    channelAvatar: (theme: Theme) => ({
        width: 40,
        height: 40,
        borderRadius: '50%',
        background: theme.palette.grey[40],
        color: theme.palette.blue[700],
        fontSize: '12px',
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    }),
    channelText: { flex: 1, minWidth: 0 } as SxProps<Theme>,
    channelName: {
        fontWeight: 700,
        fontSize: '14px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    } as SxProps<Theme>,
    channelMessage: { color: 'grey.500', fontSize: '12px' } as SxProps<Theme>,
};
